import axios from 'axios';
import configApp from './config';


axios.defaults.baseURL = configApp.baseURL;
axios.defaults.withCredentials = true

axios.interceptors.response.use(function (response) {
  if (response.request.responseURL.includes('oauth2/')) {
    window.location.href = response.request.responseURL
  }
  return response;
}, function (error) {
  if (error.response && error.response.status === 401) {
    if (!error.request.responseURL.includes('/user/info')) {
      window.location.href = "/";
    }
  } else {
    return Promise.reject(error);
  }
});

export default axios;